import { string } from 'yargs';

<template>
  <div>
    <el-tag :title="taskTitle" :class="ClassObject">{{ taskTitle }}</el-tag>
  </div>
</template>

<script>
export default {
  name: "TipoRequestsTasksFormater",
  props: {
    rowValue: {
      type: [String, Number],
      default: "",
      required: false
    },
    row: {
      type: Object,
      default: () => ({}),
      required: false
    },
    column: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  computed: {
    taskTitle() {
      switch (this.rowValue) {
        case "SI":
          return "Solicitudes Internas";
        case "SE":
          return "Solicitudes Externas";
        case "TE":
          return "Tareas Estratégicas";
        case "TO":
          return "Tareas Operacionales";
        case "RN":
          return "Reporte Navision";
        default:
          return this.rowValue;
      }
    },
    ClassObject() {
      let isred = false;
      let isyellow = false;
      let isgreen = false;
      let ispurple = false;
      let isblue = false;
      let isgray = false;

      switch (this.rowValue) {
        case "SI":
          isblue = true;
          isred = false;
          isyellow = false;
          isgreen = false;
          ispurple = false;
          isgray = false;
          break;
        case "SE":
          isgreen = true;
          isred = false;
          isyellow = false;
          ispurple = false;
          isblue = false;
          isgray = false;
          break;
        case "TE":
          ispurple = true;
          isred = false;
          isyellow = false;
          isgreen = false;
          isblue = false;
          isgray = false;
          break;
        case "TO":
          isyellow = true;
          isred = false;
          isgreen = false;
          ispurple = false;
          isblue = false;
          isgray = false;
          break;
        case "RN":
          isred = true;
          isyellow = false;
          isgreen = false;
          ispurple = false;
          isblue = false;
          isgray = false;
          break;
        default:
          isgray = true;
          isred = false;
          isyellow = false;
          isgreen = false;
          ispurple = false;
          isblue = false;
          break;
      }

      let classOject = {
        yellowBackground: isyellow,
        purpleBackground: ispurple,
        blueBackground: isblue,
        greenBackground: isgreen,
        redBackground: isred,
        greyBackground: isgray
      };

      return classOject;
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.yellowBackground {
  color: orange;
  background-color: lightyellow;
}
.purpleBackground {
  color: purple;
  background-color: lavender;
}
.blueBackground {
  color: blue;
  background-color: lightblue;
}
.greenBackground {
  color: green;
  background-color: lightgreen;
}
.redBackground {
  color: darkred;
  background-color: lightpink;
}
.greyBackground {
  color: darkgray;
  background-color: lightgrey;
}
</style>
